import React, { useState, useContext } from "react";
import { Redirect } from "react-router";
import { Button, DatePicker, Form, Input, notification } from "antd";
import SessionManager from "@Core/session";
import "@Styles/main.scss";
import AccountService from "@Services/AccountService";
import PageHelmet from "@Components/shared/PageHelmet";
import { ILegacyDetails } from "@Models/ILegacyDetails";
import { LoginOutlined } from "@ant-design/icons";
import { MainContext } from "@Context/provider";
import { ViewMode } from "@Context/state";

const ActivateLegacyPage: React.FC = () => {
    const [migrateSuccess, setMigrateSuccess] = useState(false);
    const [fetching, setFetching] = useState<boolean>(false);
    const { ui: uiState } = useContext(MainContext);
    const isDesktop = uiState.mode === ViewMode.desktop;
    const textColor = isDesktop ? { color: "black" } : { color: "white" };

    const onSubmit = async (data: ILegacyDetails) => {
        setFetching(true);
        const service = new AccountService();
        const result = await service.activateLegacy(data);
        setFetching(false);
        if (!result.hasErrors) {
            setMigrateSuccess(true);
        } else {
            notification.error({ message: result.errors.toString() });
        }
    };

    if (SessionManager.isAuthenticated && migrateSuccess) {
        return <Redirect to="/" />;
    }

    return (
        <section
            id="login-page"
            style={isDesktop ? { display: "flex", alignItems: "center", justifyContent: "center" } : null}
        >
            <PageHelmet name={"Activate"} />
            <div id="login-form">
                <p className="text-center" style={textColor}>
                    Please enter the email address you used with Lapskills, your date of birth and the{" "}
                    <b>new password</b> you wish to use.
                </p>
                <Form
                    initialValues={{} as ILegacyDetails}
                    requiredMark={false}
                    onFinish={async (values: ILegacyDetails) => {
                        await onSubmit(values);
                    }}
                >
                    <Form.Item
                        label={
                            <span className={"login-label"} style={textColor}>
                                Email
                            </span>
                        }
                        name="email"
                        required
                        rules={[{ required: true, type: "email", message: "Please enter a valid email address" }]}
                    >
                        <Input />
                    </Form.Item>

                    <Form.Item
                        label={
                            <span className={"login-label"} style={textColor}>
                                D.O.B.
                            </span>
                        }
                        name="dateOfBirth"
                        required
                        rules={[{ required: true, message: "Please enter a valid date of birth" }]}
                    >
                        <DatePicker />
                    </Form.Item>

                    <Form.Item
                        label={
                            <span className={"login-label"} style={textColor}>
                                Password
                            </span>
                        }
                        name="password"
                        required
                        rules={[{ required: true, message: "Please enter your new password." }]}
                    >
                        <Input.Password />
                    </Form.Item>

                    <Form.Item>
                        <Button
                            icon={<LoginOutlined />}
                            style={{ float: "right" }}
                            type="primary"
                            htmlType="submit"
                            loading={fetching}
                        >
                            Activate
                        </Button>
                    </Form.Item>
                </Form>
            </div>
        </section>
    );
};

export default ActivateLegacyPage;
